<template>
  <div class="solarTerms">
    <div v-if="xData.length" class="line-container">
      <div ref="lineCharts" class="myCharts line-chart" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getNewReplayFrom, getSolarTermsData } from '@/api/revive'
export default {
    name: 'SolarTerms',
    props: {
        landId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            xData: [],
            monthData: [],
            yearData: [],
            solarTerms: [],
            city: ''
        }
    },
    mounted() {
        this.initLinechart()
    },
    methods: {
        async getSolarTermsData() {
            await getSolarTermsData(this.landId).then(res => {
                if (!res) return
                this.xData = []
                this.monthData = []
                this.yearData = []
                this.solarTerms = []
                res.forEach(item => {
                    const date = moment(item.dataTime).format('YY-MM')
                    this.xData.push(date)
                    this.monthData.push((item.monthHbJgzf * 100).toFixed(2))
                    this.yearData.push((item.yearTbJgzf * 100).toFixed(2))
                    this.solarTerms.push(item.jieqi)
                })
            })
        },
        getNewReplayFrom() {
            getNewReplayFrom(this.landId).then(res => {
                if (res) {
                    this.city = res.city
                }
            })
        },
        async initLinechart() {
            this.getNewReplayFrom()
            await this.getSolarTermsData()
            const lineChart = this.$echarts.init(this.$refs.lineCharts)
            setTimeout(() => {
                lineChart.setOption({
                    xAxis: {
                        type: 'category',
                        data: this.xData,
                        boundaryGap: false
                    },
                    yAxis: {
                        type: 'value'
                    },
                    title: {
                        text: `${this.city}节气图`,
                        textStyle: {
                            fontSize: 14
                        }
                    },
                    legend: { data: ['年同比价格涨幅', '月环比价格涨幅'], top: 30 },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (data) => {
                            let temp = `${data[0].name} <br/>`
                            data.forEach(item => { temp += `<div><span style="display: inline-block;width: 120px">${item.seriesName} </span>${ item.value }%</div>` })
                            return temp
                        }
                    },
                    dataZoom: [
                        {
                            type: 'slider',
                            show: true
                        }
                    ],
                    series: [
                        {
                            name: '年同比价格涨幅',
                            data: this.yearData,
                            type: 'line',
                            smooth: true
                        },
                        {
                            name: '月环比价格涨幅',
                            data: this.monthData,
                            type: 'line',
                            label: {
                                show: true,
                                position: 'top',
                                formatter: params => {
                                    return this.solarTerms[params.dataIndex] || ''
                                }
                            },
                            smooth: true
                        }]

                })
            }, 300)
        }
    }
}
</script>

<style lang="scss" scoped>
    .solarTerms {
        .line-container {
            .line-chart {
                height:6.5rem /* 395/100 */
            }
        }
    }
</style>
